module.exports = __webpack_public_path__ + "media/club_product_v2/4-4ee86d7b.webp";